<template>
    <v-dialog v-model="dialog" max-width="720" scrollable persistent>
        <v-card>
            <v-toolbar dark color="primary" flat>
                <v-toolbar-title>{{ $t('updateNotes.modal.title') }}</v-toolbar-title>
                <v-spacer />
                <v-btn icon dark @click="closeWithoutMarking">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text class="pt-4">
                <div v-for="release in releases" :key="release.id_nota_atualizacao" class="mb-6">
                    <div class="text-h6 primary--text">{{ release.versao }}</div>
                    <div v-if="release.titulo" class="subtitle-1 mb-1">{{ release.titulo }}</div>
                    <div class="text-caption grey--text mb-3">{{ release.dt_lancamento_extenso }}</div>

                    <v-card
                        v-for="item in release.itens"
                        :key="item.id_item"
                        outlined
                        class="mb-3"
                    >
                        <v-card-title class="py-2">
                            <v-chip x-small :color="tipoColor(item.tipo_alteracao)" class="white--text mr-2">
                                {{ tipoLabel(item.tipo_alteracao) }}
                            </v-chip>
                            <span class="subtitle-2">{{ item.titulo }}</span>
                        </v-card-title>
                        <v-card-text class="pt-0">
                            <div class="mb-2">{{ item.descricao }}</div>
                            <div class="caption font-weight-medium">{{ $t('updateNotes.howToVerify') }}</div>
                            <div class="caption">{{ item.como_verificar }}</div>
                        </v-card-text>
                    </v-card>
                </div>
            </v-card-text>

            <v-divider />

            <v-card-actions class="px-4 py-3">
                <v-btn text color="primary" @click="goToHistory">
                    {{ $t('updateNotes.modal.viewHistory') }}
                </v-btn>
                <v-spacer />
                <v-btn color="primary" dark :loading="loading" @click="acknowledge">
                    {{ $t('updateNotes.modal.confirm') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import apiController from '@/utils/apiController';

export default {
    name: 'UpdateNotesModal',
    data: () => ({
        dialog: false,
        loading: false,
        releases: [],
        token: null,
    }),
    created() {
        this.$root.$on('checkUpdateNotes', this.fetchUnviewed);
        this.$root.$on('localeChanged', this.onLocaleChanged);
    },
    mounted() {
        if (this.$route.matched.some((record) => record.meta.requiresAuth)) {
            this.fetchUnviewed();
        }
    },
    beforeDestroy() {
        this.$root.$off('checkUpdateNotes', this.fetchUnviewed);
        this.$root.$off('localeChanged', this.onLocaleChanged);
    },
    methods: {
        onLocaleChanged() {
            if (this.dialog) {
                this.fetchUnviewed(true);
            }
        },
        fetchUnviewed(keepOpen) {
            this.token = sessionStorage.getItem('api');
            if (!this.token || !sessionStorage.getItem('user')) {
                return;
            }

            apiController.request(apiController.endpoints.getNotasatualizacaonaovistas, {
                silent: true,
                onSuccess: (response) => {
                    if (response.data.erro) {
                        return;
                    }

                    this.releases = response.data.releases || [];
                    if (this.releases.length > 0) {
                        this.dialog = true;
                    } else if (!keepOpen) {
                        this.dialog = false;
                    }
                },
                onError: () => {
                    if (!keepOpen) {
                        this.dialog = false;
                    }
                },
            });
        },
        acknowledge() {
            if (!this.releases.length) {
                this.dialog = false;
                return;
            }

            this.loading = true;
            const ids = this.releases.map((r) => r.id_nota_atualizacao);

            const finalizar = () => {
                this.loading = false;
                this.dialog = false;
                this.releases = [];
            };
            apiController.request(apiController.endpoints.marcarnotasvisualizadas, {
                data: { ids },
                silent: true,
                onSuccess: finalizar,
                onError: finalizar,
            });
        },
        closeWithoutMarking() {
            this.dialog = false;
        },
        goToHistory() {
            this.dialog = false;
            if (this.$route.path !== '/notas-atualizacao') {
                this.$router.push({ path: '/notas-atualizacao' });
            }
        },
        tipoLabel(tipo) {
            const key = `updateNotes.types.${tipo}`;
            return this.$te(key) ? this.$t(key) : tipo;
        },
        tipoColor(tipo) {
            const map = {
                correcao: 'orange darken-2',
                melhoria: 'blue darken-2',
                nova_funcionalidade: 'green darken-2',
                ui_ux: 'purple darken-2',
            };
            return map[tipo] || 'grey darken-1';
        },
    },
};
</script>
